<template>
    <div class="table-responsive m-0 p-0 mt-5 mb-5">
        <table class="table p-0 m-0">
            <tr>
                <td style="width: 33%; padding-left: 10px !important;">
                    <router-link to="/seguros-venta-y-asesoria-individuos">
                        <button class="btn btn-primary" :class="(activo == 'individuos') ? 'active' : ''">Individuos y familias</button>
                    </router-link>
                </td>
                <td style="width: 33%;">
                    <router-link to="/seguros-venta-y-asesoria-profesionales">
                        <button class="btn btn-primary" :class="(activo == 'profesionales') ? 'active' : ''">Profesionales independientes y Pymes</button>
                    </router-link>
                </td>
                <td style="width: 33%;">
                    <router-link to="/seguros-venta-y-asesoria-empresas">
                        <button class="btn btn-primary" :class="(activo == 'empresas') ? 'active' : ''">Empresas y corporativos</button>
                    </router-link>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
  name: 'Botones',
  props: {
    activo: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table td, .table th {
    border: none !important;
}
.btn-primary {
    margin-top: 20px;
    margin: 20px 5px 0 5px;
    background-color: #FFF !important;
    border-radius: 0;
    border: 4px solid #1900FF;
    padding: 10px 10px 10px 10px;
    color: #000;
    font-weight: 700;
    text-decoration: none;
    width: 100%;
}
.btn-primary.active {
    background-color: #08028A !important;
    border: 4px solid #00C4FF !important;
}
td {
    text-align: center;
}
@media only screen and (max-width: 990px){
    .btn-primary {
        width: 145px;
        font-size: 14px;
        text-decoration: none;
        padding: 6px 10px 6px 10px;
        height: 90px;
    }
}
@media only screen and (max-width: 767px){
    .table-responsive {
        margin-left: -15px !important;
        margin-right: -15px !important;
        width: auto !important;
    }
    td {
        padding: 2px !important;
    }
}
@media only screen and (min-width: 990px) and (max-width: 1024px){
    .btn-primary {
        height: 76px !important;
    }
}
@media only screen and (min-width: 1024px){
    .btn-primary:hover {
        background-color: #1900FF !important;
        color: #FFF;
    }
}
</style>
